
import { FormPicture } from "../FormSection"

export function TabPicture() {
    return <FormPicture />
}